// @ts-nocheck fb0459f9
import * as addPanel from '#packages/oldAddPanel';

export default {
  getCategorySections() {
    return addPanel.dataUtil.mergeWithCommonSections(
      addPanel.sections.getSections().vectorArt,
      {},
    );
  },
};
